import React from 'react';

const HomeMigrar2 = props => {
  return (
      <div></div>
  )
}

export default HomeMigrar2